<div *ngIf="!showForm">
    <div mat-dialog-title>
        <h2 style="margin: 0px;">Related EAM {{priorWorkRequest.workrequest_data.EAM_TYPE}}</h2>
    </div>
    <div mat-dialog-content >
        <div>
            On {{priorWorkRequest.time_period}} the following {{priorWorkRequest.workrequest_data.EAM_TYPE}} was related to this task.
        </div>
        <mat-card  appearance="outlined" class="workordercard mat-elevation-z8" >
            <mat-card-title>
            <div class="fx-row-space-evenly-center">
                <div class="fx-column-space-between-center">
                <div >Creation Time </div>
                <div >{{priorWorkRequest.workrequest_data.CREATION_DATE | date:'short'}}</div>
                </div>
                <div class="fx-column-space-between-center" >
                <div >Work Item</div>
                <div >{{priorWorkRequest.workrequest_data.WR_WO_NUMBER}}</div>
                </div>
            </div>
            </mat-card-title>
            <mat-card-content>
                    <div> <b> Description</b></div>
                    <div> 
                    {{priorWorkRequest.workrequest_data.DESCRIPTION}} 
                    </div>
                    <div> <b> Work Type</b></div>
                    <div> {{priorWorkRequest.workrequest_data.WORK_TYPE}}</div>
                    <div ><b>Status</b></div>
                    <div >{{priorWorkRequest.workrequest_data.STATUS}}</div>
                    <div ><b>Priority</b></div>
                    <div >{{priorWorkRequest.workrequest_data.PRIORTY}}</div>
                    <div ><b>ASSET NUMBER</b></div>
                    <div >{{priorWorkRequest.workrequest_data.ASSET_NUMBER}}</div>
            </mat-card-content>
        </mat-card>
    </div>

    <div mat-dialog-actions class="action-container">
        <div class="action-question">
            Associate with {{priorWorkRequest.workrequest_data.EAM_TYPE}}?
        </div>
        <div class="action-buttons">
                <button *ngIf="required_input && required_input != ''" mat-raised-button color="primary" (click)="showFormInput()">Yes</button>
                <button *ngIf="!required_input || required_input == ''" mat-raised-button color="primary" (click)="save()">Yes</button>
                <button mat-raised-button (click)="close(openNext=true)">No</button>
        </div>
    </div>
</div>

<!-- IF REQUIRED INPUT QUESTION, SHOWS BEFORE SAVING -->
<div *ngIf="showForm">
    <div mat-dialog-title>
        <h2 style="margin: 0px;">Required Input</h2>
    </div>
    <div mat-dialog-content *ngIf="showForm">
        <form [formGroup]="requiredInputForm">
        <mat-form-field class="card-dialog">
            <mat-label>{{required_input}}</mat-label>
            <textarea  matInput cdkTextareaAutosize formControlName="input_data"></textarea>
        </mat-form-field> 
        </form>
    </div>

    <div mat-dialog-actions class="action-container">
        <div class="action-save-buttons">
                <button mat-raised-button [disabled]="processing" color="primary" (click)="save()">Save</button> 
                <button mat-raised-button (click)="close(false)">Cancel</button> 
        </div>
    </div>
</div>